import { blackScholesModelCalculationService } from "../BlackScholesModelCalculationService";
import dayjs from "dayjs";
import { BasePortfolioPositionsCalculationService } from "./abstracts/BasePortfolioPositionsCalculationService";
import { PortfolioGroupedItem } from "../../../screens/positions-and-orders/models/PortfolioGroupedItem";

export class PortfolioPositionsDeltaCalculationService extends BasePortfolioPositionsCalculationService {
    protected calculateForFutures(position: PortfolioGroupedItem): number {
        return position.currentSize;
    }

    protected calculateForOption(positionModel: PortfolioGroupedItem,
        underlyingPrice: number, timeToExpirationInShareOfYear: number,
        getImpliedVolatility: (position: PortfolioGroupedItem) => number,
    ): number {
        const isExpired = positionModel.expireAt !== null
            ? blackScholesModelCalculationService.getTimeToExpirationInShareOfYear(positionModel.expireAt, dayjs().toDate()) < 0
            : true;

        if (isExpired) {
            // todo: calc option price after expiration
            return 0;
        }
        
        if (positionModel.impliedVolatility === null) {
            throw new Error("ImpliedVolatility cannot be null!");
        }

        if (positionModel.strike === null) {
            throw new Error("Portfolio item property 'strike' is null.")
        }
        
        return blackScholesModelCalculationService.getDelta(
            positionModel.type, underlyingPrice, positionModel.strike, timeToExpirationInShareOfYear, getImpliedVolatility(positionModel));
    }
}